<script>
  export default {

    inject: ['$validator'],

    props: {
      classes: {
        type: Object,
        required: false,
        default: function() {
          return {};
        },
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      id: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      validations: {
        type: Object,
        required: false,
        default: function() {
          return {};
        },
      },
      value: {
        required: true,
      },
    },

  };
</script>



// WEBPACK FOOTER //
// App.vue?18d56d24